import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _createSuper from '@babel/runtime/helpers/esm/createSuper';
import { AnalyticsApplication, AbstractSegmentServiceV2 } from '@landr/core';

var CtaGoal = /*#__PURE__*/function (CtaGoal) {
  CtaGoal["AccessCoursePack"] = "Access Course Pack";
  CtaGoal["AccessMusixmatch"] = "Access Musixmatch";
  CtaGoal["AddClients"] = "Add Clients";
  CtaGoal["AddtoCalendarGoogle"] = "Add to Calendar - Google";
  CtaGoal["AddtoCalendariCal"] = "Add to Calendar - iCal";
  CtaGoal["AddtoCalendarOutlook"] = "Add to Calendar - Outlook";
  CtaGoal["AllowFileDownload"] = "Allow File Download";
  CtaGoal["BacktoPreviousStep"] = "Back to Previous Step";
  CtaGoal["BrowseFreeSamples"] = "Browse Free Samples";
  CtaGoal["BrowseNetwork"] = "Browse Network";
  CtaGoal["BrowsePros"] = "Browse Pros";
  CtaGoal["BrowseSamples"] = "Browse Samples";
  CtaGoal["BrowseServiceCategory"] = "Browse Service Category";
  CtaGoal["BrowseTopService"] = "Browse Top Service";
  CtaGoal["BuySamples1000Credits"] = "Buy Samples 1000 Credits";
  CtaGoal["BuyUnlimitedMP3"] = "Buy Unlimited MP3";
  CtaGoal["Checkout"] = "Checkout";
  CtaGoal["CompleteProfileOver50Percent"] = "Complete Profile Over 50 Percent";
  CtaGoal["CopyLink"] = "Copy Link";
  CtaGoal["CopyPromolink"] = "Copy Promolink";
  CtaGoal["CreateProfile"] = "Create Profile";
  CtaGoal["CreateQuote"] = "Create Quote";
  CtaGoal["Download3rdPartyPlugin"] = "Download 3rd Party Plugin";
  CtaGoal["DownloadPluginLandrFXAccoustic"] = "Download Plugin - Landr FX Accoustic";
  CtaGoal["DownloadPluginLandrFXBass"] = "Download Plugin - Landr FX Bass";
  CtaGoal["DownloadPluginLandrFXBeats"] = "Download Plugin - Landr FX Beats";
  CtaGoal["DownloadPluginLandrFXElectric"] = "Download Plugin - Landr FX Electric";
  CtaGoal["DownloadPluginLandrFXVoice"] = "Download Plugin - Landr FX Voice";
  CtaGoal["DownloadPluginLandrGuitar"] = "Download Plugin - Landr Guitar";
  CtaGoal["DownloadPluginLethal"] = "Download Plugin - Lethal";
  CtaGoal["DownloadSample"] = "Download Sample";
  CtaGoal["DownloadVocAlign"] = "Download VocAlign";
  CtaGoal["FavouriteSample"] = "Favourite Sample";
  CtaGoal["FindaPro"] = "Find a Pro";
  CtaGoal["GetALC"] = "Get ALC";
  CtaGoal["GetDeal"] = "Get Deal";
  CtaGoal["GetMixFeedback"] = "Get Mix Feedback";
  CtaGoal["GetNewFormat"] = "Get New Format";
  CtaGoal["GetTier1Plan"] = "Get Tier 1 Plan";
  CtaGoal["GetTier2Plan"] = "Get Tier 2 Plan";
  CtaGoal["GetTier3Plan"] = "Get Tier 3 Plan";
  CtaGoal["GotoChromatic"] = "Go to Chromatic";
  CtaGoal["GotoCommunityChannels"] = "Go to Community Channels";
  CtaGoal["GotoCourses"] = "Go to Courses";
  CtaGoal["GotoCreator"] = "Go to Creator";
  CtaGoal["GotoDistribution"] = "Go to Distribution";
  CtaGoal["GotoLibrary"] = "Go to Library";
  CtaGoal["GotoMessages"] = "Go to Messages";
  CtaGoal["GotoNetwork"] = "Go to Network";
  CtaGoal["GotoPlugins"] = "Go to Plugins";
  CtaGoal["GotoProjects"] = "Go to Projects";
  CtaGoal["GotoSamples"] = "Go to Samples";
  CtaGoal["GotoSessions"] = "Go to Sessions";
  CtaGoal["GotoStripeBilling"] = "Go to Stripe Billing";
  CtaGoal["InstallPluginLandrFXAccoustic"] = "Install Plugin - Landr FX Accoustic";
  CtaGoal["InstallPluginLandrFXBass"] = "Install Plugin - Landr FX Bass";
  CtaGoal["InstallPluginLandrFXBeats"] = "Install Plugin - Landr FX Beats";
  CtaGoal["InstallPluginLandrFXElectric"] = "Install Plugin - Landr FX Electric";
  CtaGoal["InstallPluginLandrFXSuite"] = "Install Plugin - Landr FX Suite";
  CtaGoal["InstallPluginLandrFXVoice"] = "Install Plugin - Landr FX Voice";
  CtaGoal["InstallPluginLandrGuitar"] = "Install Plugin - Landr Guitar";
  CtaGoal["InstallPluginLethal"] = "Install Plugin - Lethal";
  CtaGoal["JoinSession"] = "Join Session";
  CtaGoal["LearnaboutChromatic"] = "Learn about Chromatic";
  CtaGoal["LearnaboutSessions"] = "Learn about Sessions";
  CtaGoal["NextStep1"] = "Next Step 1";
  CtaGoal["NextStep2"] = "Next Step 2";
  CtaGoal["NextStep3"] = "Next Step 3";
  CtaGoal["NextStep4"] = "Next Step 4";
  CtaGoal["OpeninCreator"] = "Open in Creator";
  CtaGoal["RedeemLicence"] = "Redeem Licence";
  CtaGoal["ReviewOrder"] = "Review Order";
  CtaGoal["SearchNetwork"] = "Search Network";
  CtaGoal["ShowMore"] = "Show More";
  CtaGoal["SkipStep1"] = "Skip Step 1";
  CtaGoal["SkipStep2"] = "Skip Step 2";
  CtaGoal["SkipStep3"] = "Skip Step 3";
  CtaGoal["SkipStep4"] = "Skip Step 4";
  CtaGoal["StartNewMessage"] = "Start New Message";
  CtaGoal["StartVocAlign"] = "Start VocAlign";
  CtaGoal["ToggleOffAutoTrigger"] = "Toggle Off Auto-Trigger";
  CtaGoal["ToggleOnAutoTrigger"] = "Toggle On Auto-Trigger";
  CtaGoal["TryCreator"] = "Try Creator";
  CtaGoal["TurnOffAutoPlay"] = "Turn Off Auto-Play";
  CtaGoal["TurnOnAutoPlay"] = "Turn On Auto-Play";
  CtaGoal["UpgradeDistributionPlan"] = "Upgrade Distribution Plan";
  CtaGoal["UpgradeMasteringPlan"] = "Upgrade Mastering Plan";
  CtaGoal["UpgradePlan"] = "Upgrade Plan";
  CtaGoal["ViewAAPPricing"] = "View AAP Pricing";
  CtaGoal["ViewAdvancedMasterSettings"] = "View Advanced Master Settings";
  CtaGoal["ViewAutoTunePlugin"] = "View Auto-Tune Plugin";
  CtaGoal["ViewBeeperPlugin"] = "View Beeper Plugin";
  CtaGoal["ViewBlueCatFlangerPlugin"] = "View Blue Cat Flanger Plugin";
  CtaGoal["ViewBoogexPlugin"] = "View Boogex Plugin";
  CtaGoal["ViewDesktopAppLandingPage"] = "View Desktop App Landing Page";
  CtaGoal["ViewDetail"] = "View Detail";
  CtaGoal["ViewDistrokidComparison"] = "View Distrokid Comparison";
  CtaGoal["ViewLandrFXBundle"] = "View Landr FX Bundle";
  CtaGoal["ViewLandrFXPlugin"] = "View Landr FX Plugin";
  CtaGoal["ViewLatencyPlugin"] = "View Latency Plugin";
  CtaGoal["ViewLethalPlugin"] = "View Lethal Plugin";
  CtaGoal["ViewMessages"] = "View Messages";
  CtaGoal["ViewNewDropdown"] = "View New Dropdown";
  CtaGoal["ViewNotifications"] = "View Notifications";
  CtaGoal["ViewOldSkoolVerbPlusPlugin"] = "View OldSkoolVerb Plus Plugin";
  CtaGoal["ViewOvertoneGEQPlugin"] = "View Overtone GEQ Plugin";
  CtaGoal["ViewPanCakePlugin"] = "View PanCake Plugin";
  CtaGoal["ViewPlugin"] = "View Plugin";
  CtaGoal["ViewPricing"] = "View Pricing";
  CtaGoal["ViewProject"] = "View Project";
  CtaGoal["ViewPromolink"] = "View Promolink";
  CtaGoal["ViewRecorderPlugin"] = "View Recorder Plugin";
  CtaGoal["ViewReferralRewards"] = "View Referral Rewards";
  CtaGoal["ViewSamplesPlugin"] = "View Samples Plugin";
  CtaGoal["ViewServices"] = "View Services";
  CtaGoal["ViewSessionsPlugin"] = "View Sessions Plugin";
  CtaGoal["ViewSessionsShortcut"] = "View Sessions Shortcut";
  CtaGoal["ViewSpanPlugin"] = "View Span Plugin";
  CtaGoal["ViewStereoTouchPlugin"] = "View Stereo Touch Plugin";
  CtaGoal["ViewStudioYearlyCourses"] = "View Studio Yearly Courses";
  CtaGoal["ViewTripleEQ4Plugin"] = "View Triple EQ 4 Plugin";
  CtaGoal["WaitzineLinkClick"] = "Waitzine Link Click";
  CtaGoal["WatchReferenceMasteringVideo"] = "Watch Reference Mastering Video";
  return CtaGoal;
}({});
var CtaType = /*#__PURE__*/function (CtaType) {
  CtaType["Button"] = "Button";
  CtaType["Card"] = "Card";
  CtaType["Dropdown"] = "Dropdown";
  CtaType["EllipsisMenu"] = "Ellipsis Menu";
  CtaType["PlainText"] = "Plain Text";
  return CtaType;
}({});
var InteractionSource = /*#__PURE__*/function (InteractionSource) {
  InteractionSource["AddAction"] = "Add Action";
  InteractionSource["AssetAction"] = "Asset Action";
  InteractionSource["AssetActionDropdown"] = "Asset Action - Dropdown";
  InteractionSource["AssetActionFeed"] = "Asset Action - Feed";
  InteractionSource["AssetActionFile"] = "Asset Action - File";
  InteractionSource["AssetActionMain"] = "Asset Action - Main";
  InteractionSource["Automatic"] = "Automatic";
  InteractionSource["Banner"] = "Banner";
  InteractionSource["BellNotification"] = "Bell Notification";
  InteractionSource["BounceFolder"] = "Bounce Folder";
  InteractionSource["CalloutBanner"] = "Callout Banner";
  InteractionSource["CancelConfirmationModal"] = "Cancel Confirmation Modal";
  InteractionSource["CancelFeatureLossModal"] = "Cancel Feature Loss Modal";
  InteractionSource["CancelOptions"] = "Cancel Options";
  InteractionSource["CancelReasonModal"] = "Cancel Reason Modal";
  InteractionSource["CardAction"] = "Card Action";
  InteractionSource["CategoryTitle"] = "Category Title";
  InteractionSource["CommentAction"] = "Comment Action";
  InteractionSource["CompareModal"] = "Compare Modal";
  InteractionSource["CreatorAction"] = "Creator Action";
  InteractionSource["Direct"] = "Direct";
  InteractionSource["DownloadAllAction"] = "Download All Action";
  InteractionSource["DragandDrop"] = "Drag and Drop";
  InteractionSource["Email"] = "Email";
  InteractionSource["InvitationModal"] = "Invitation Modal";
  InteractionSource["LibraryAction"] = "Library Action";
  InteractionSource["LibraryTray"] = "Library Tray";
  InteractionSource["MainAction"] = "Main Action";
  InteractionSource["MasterFormatModal"] = "Master Format Modal";
  InteractionSource["MasterPreviewModal"] = "Master Preview Modal";
  InteractionSource["MasterWaitzine"] = "Master Waitzine";
  InteractionSource["MasterWaitzineSlide1"] = "Master Waitzine - Slide 1";
  InteractionSource["MasterWaitzineSlide2"] = "Master Waitzine - Slide 2";
  InteractionSource["MasterWaitzineSlide3"] = "Master Waitzine - Slide 3";
  InteractionSource["MasterWaitzineSlide4"] = "Master Waitzine - Slide 4";
  InteractionSource["MasterWaitzineSlide5"] = "Master Waitzine - Slide 5";
  InteractionSource["MasterWaitzineSlide6"] = "Master Waitzine - Slide 6";
  InteractionSource["MessagesAction"] = "Messages Action";
  InteractionSource["MessagesDropdown"] = "Messages Dropdown";
  InteractionSource["MultiselectAction"] = "Multiselect Action";
  InteractionSource["Navbar"] = "Navbar";
  InteractionSource["NewAction"] = "New Action";
  InteractionSource["NewActionAlbumMaster"] = "New Action - Album Master";
  InteractionSource["NewActionMaster"] = "New Action - Master";
  InteractionSource["NewActionUpload"] = "New Action - Upload";
  InteractionSource["NewFormatDropdown"] = "New Format Dropdown";
  InteractionSource["Notification"] = "Notification";
  InteractionSource["PlanDetailModal"] = "Plan Detail Modal";
  InteractionSource["PluginCard"] = "Plugin Card";
  InteractionSource["Popover"] = "Popover";
  InteractionSource["PricingNav"] = "Pricing Nav";
  InteractionSource["ProfileCardAction"] = "Profile Card Action";
  InteractionSource["ProfileSurvey"] = "Profile Survey";
  InteractionSource["ProjectsAction"] = "Projects Action";
  InteractionSource["ReleaseSplitDetailModal"] = "Release Split Detail Modal";
  InteractionSource["RoomCard"] = "Room Card";
  InteractionSource["ServiceBrief"] = "Service Brief";
  InteractionSource["ServiceQuote"] = "Service Quote";
  InteractionSource["SessionsNavbarShortcut"] = "Sessions Navbar Shortcut";
  InteractionSource["SettingAction"] = "Setting Action";
  InteractionSource["SharedLink"] = "Shared Link";
  InteractionSource["StartVocAlignModal"] = "Start VocAlign Modal";
  InteractionSource["TextAction"] = "Text Action";
  InteractionSource["TrendingCharts"] = "Trending Charts";
  InteractionSource["UpdateModal"] = "Update Modal";
  InteractionSource["UpsellCard"] = "Upsell Card";
  InteractionSource["UpsellModal"] = "Upsell Modal";
  InteractionSource["UpsellModalFreeUserFreeDownload"] = "Upsell Modal - Free User Free Download";
  InteractionSource["UpsellModalFreeUserPaidDownload"] = "Upsell Modal - Free User Paid Download";
  InteractionSource["UpsellModalPaidUserPaidDownload"] = "Upsell Modal - Paid User Paid Download";
  InteractionSource["UseCreditModal"] = "Use Credit Modal";
  InteractionSource["WaitzineWhileMastering"] = "Waitzine While Mastering";
  InteractionSource["WaitzineWhilePBS"] = "Waitzine While PBS";
  InteractionSource["WaitzineWhilePreviewing"] = "Waitzine While Previewing";
  InteractionSource["WelcomeModal"] = "Welcome Modal";
  return InteractionSource;
}({});
var PlatformAnalyticsV2Service = /*#__PURE__*/function (_AbstractSegmentServi) {
  _inherits(PlatformAnalyticsV2Service, _AbstractSegmentServi);
  var _super = _createSuper(PlatformAnalyticsV2Service);
  function PlatformAnalyticsV2Service(platformNameOverride) {
    _classCallCheck(this, PlatformAnalyticsV2Service);
    return _super.call(this, AnalyticsApplication.Platform, typeof window === 'undefined' ? undefined : window, platformNameOverride);
  }
  /**
   * Triggered when a user clicks a CTA button on a page. See Notion page for all details of when CTA Clicked is triggered on the website: https://www.notion.so/landr/CTA-Clicked-cc35afb358ca4765ae7c55b19d8a2715
   */
  _createClass(PlatformAnalyticsV2Service, [{
    key: "trackCTAClicked",
    value: function trackCTAClicked(properties) {
      var _properties$ctaConten, _properties$ctaConten2, _properties$ctaDestin, _properties$ctaText;
      return this.track('CTA Clicked', {
        cta_goal: properties.ctaGoal,
        cta_type: properties.ctaType,
        interaction_source: properties.interactionSource,
        cta_content_group: (_properties$ctaConten = properties.ctaContentGroup) !== null && _properties$ctaConten !== void 0 ? _properties$ctaConten : null,
        cta_content_list: (_properties$ctaConten2 = properties.ctaContentList) !== null && _properties$ctaConten2 !== void 0 ? _properties$ctaConten2 : null,
        cta_destination: (_properties$ctaDestin = properties.ctaDestination) !== null && _properties$ctaDestin !== void 0 ? _properties$ctaDestin : null,
        cta_text: (_properties$ctaText = properties.ctaText) !== null && _properties$ctaText !== void 0 ? _properties$ctaText : null
      });
    }
  }]);
  return PlatformAnalyticsV2Service;
}(AbstractSegmentServiceV2);

export { CtaGoal, CtaType, InteractionSource, PlatformAnalyticsV2Service };
